import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  getOurteam,
  removeOurteam,
  updateOurteam,
} from 'slice/ourteamSlice';
import AdminTable from 'common/AdminTable';
import TruncatedMessage from 'common/TruncatedMessage';
import { toast } from 'react-toastify';

const ListOurteam = () => {
  const dispatch = useDispatch();
  const { data: teamData } = useSelector((state) => state.ourteam);

  const [selectedTeamMember, setSelectedTeamMember] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    role: '',
    description: '',
    image: null,
    existingImage: '',
  });

  useEffect(() => {
    dispatch(getOurteam());
  }, [dispatch]);

  const handleEditClick = (member) => {
    setSelectedTeamMember(member);
    setFormData({
      name: member.name,
      role: member.role,
      description: member.description,
      image: null,
      existingImage: `${process.env.REACT_APP_BACKEND}team/${member.image}`,
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedTeamMember(null);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, image: file }));
  };

  const handleSaveChanges = async () => {
    const updatedData = new FormData();
    updatedData.append('name', formData.name);
    updatedData.append('role', formData.role);
    updatedData.append('description', formData.description);
    if (formData.image) updatedData.append('image', formData.image);

    try {
      await dispatch(updateOurteam({ id: selectedTeamMember.id, data: updatedData }));
      toast('Team member updated successfully!');
      dispatch(getOurteam());
    } catch (error) {
      console.error(error);
      toast('Failed to update team member');
    }

    closeModal();
  };

  const tableHeaders = [
    { Header: 'ID', accessor: 'id' },
    {
      Header: 'Image',
      accessor: 'image',
      Cell: ({ row }) => (
        <img
          src={`${process.env.REACT_APP_BACKEND}team/${row.original.image}`}
          alt={row.original.name}
          width={50}
        />
      ),
    },
    { Header: 'Name', accessor: 'name' },
    { Header: 'Role', accessor: 'role' },
    {
      Header: 'Description',
      accessor: 'description',
      Cell: ({ row }) => <TruncatedMessage text={row.original.description} maxLength={30} />,
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button
            className="btn removebtn mx-1"
            onClick={() => dispatch(removeOurteam(row.original.id))}
          >
            Remove
          </button>
          <button
            className="btn editbtn mx-1"
            onClick={() => handleEditClick(row.original)}
          >
            Edit
          </button>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="container-fluid mt-5">
        <div className="mainheadig mx-4">
          <h4 className="text-white font-weight-bold">Our Team List</h4>
        </div>

        {teamData?.length > 0 && <AdminTable tableHeaders={tableHeaders} tableData={teamData} />}
      </div>

      {showModal && selectedTeamMember && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Team Member</h5>
                <button type="button" className="close" onClick={closeModal}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleFormChange}
                  className="form-control mb-2"
                  placeholder="Name"
                />
                <input
                  type="text"
                  name="role"
                  value={formData.role}
                  onChange={handleFormChange}
                  className="form-control mb-2"
                  placeholder="Role"
                />
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleFormChange}
                  className="form-control mb-2"
                  placeholder="Description"
                />
                <input
                  type="file"
                  name="image"
                  onChange={handleImageChange}
                  className="form-control mb-2"
                  accept="image/*"
                />

                <img
                  src={formData.image ? URL.createObjectURL(formData.image) : formData.existingImage}
                  alt="Preview"
                  width={100}
                  className="mt-2"
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeModal}>Close</button>
                <button className="btn btn-primary" onClick={handleSaveChanges}>Save Changes</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ListOurteam;
